import React, { useState, useEffect } from "react";
import blessings from "../data/blessings"
import fixedData from "../data/fixedData";




import { Container, Row, Col } from 'react-bootstrap';

const getBlessingOfTheDay = () => {
    const today = new Date();
    return blessings[today.getDate() % blessings.length]; // คำนวณแบบวนวัน
};

const Welcome = () => {
    const today = new Date();
    const dayNames = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"];
    const dayName = dayNames[today.getDay()];
    const blessing = getBlessingOfTheDay();

    const [salaryInfo, setSalaryInfo] = useState("");

    useEffect(() => {
        updateSalaryInfo();
    }, []);


    const getNextSalaryDay = (baseDate = new Date()) => {
        let currentYear = baseDate.getFullYear();
        let currentMonth = baseDate.getMonth();
        let lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

        // กำหนดวันที่เงินเดือนออก (ถ้าเดือนมีไม่ถึง 29 วัน จะใช้วันสุดท้ายของเดือนแทน)
        let salaryDay = new Date(currentYear, currentMonth, Math.min(29, lastDayOfMonth));

        // ปรับวันเงินเดือนออกถ้าตรงกับเสาร์-อาทิตย์
        if (salaryDay.getDay() === 6) {
            salaryDay.setDate(salaryDay.getDate() - 1); // เลื่อนไปศุกร์ที่ 28
        } else if (salaryDay.getDay() === 0) {
            salaryDay.setDate(salaryDay.getDate() - 2); // เลื่อนไปศุกร์ที่ 27
        }

        return salaryDay;
    };

    const updateSalaryInfo = () => {
        // const testDate = new Date(2025, 5, 27); // Mock วันที่ 29 เมษายน 2025
        // let today = testDate;
        let today = new Date();
        let salaryDay = getNextSalaryDay(today);
    
        console.log("📅 Today:", today.toDateString());
        console.log("💰 Salary Day:", salaryDay.toDateString());
    
        // 🟢 ถ้าวันนี้เป็นวันเงินเดือนออก
        if (
            today.getFullYear() === salaryDay.getFullYear() &&
            today.getMonth() === salaryDay.getMonth() &&
            today.getDate() === salaryDay.getDate()
        ) {
            setSalaryInfo("ได้เวลาเก็บเกี่ยวผลจากการทำงานหนักแล้ว! 🎉");
            return;
        }
    
        // 🛠 ถ้าเลยวันเงินเดือนออกไปแล้ว ให้คำนวณของเดือนถัดไป
        if (today > salaryDay) {
            salaryDay = getNextSalaryDay(new Date(today.getFullYear(), today.getMonth() + 1, 1));
        }
    
        // 🟢 ใช้เวลาเที่ยงคืนเพื่อคำนวณต่างวัน
        const resetTimeToMidnight = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());
    
        let todayMidnight = resetTimeToMidnight(today);
        let salaryMidnight = resetTimeToMidnight(salaryDay);
    
        let timeDiff = salaryMidnight - todayMidnight;
        let daysLeft = timeDiff / (1000 * 60 * 60 * 24);
    
        setSalaryInfo(`แค่ ${daysLeft} วัน สู่การเก็บเกี่ยวผลจากความมุ่งมั่น!`);
    };
    
    


    return (
        <Container className="box-contact">
            <h1>สวัสดีวัน{dayName}!</h1>
            <span>{blessing}</span>

            <Row className="justify-content-center mt-3">
                {fixedData.map((item, index) => (
                    <Col key={index} xs={6} sm={3} md={3} className="mb-3 p-3 rounded shadow text-center">
                        <a href={item.url || "#"} target="_blank" rel="noopener noreferrer" className="data-card pointer mb-2">
                            <div className="data-card pointer mb-2">
                                {item.icon && <img src={item.icon} alt={item.value} width="50%" />}
                            </div>
                        </a>
                        <a href={item.url || "#"} target="_blank" rel="noopener noreferrer" className="pointer mb-2 text">
                            {item.value}
                        </a>
                    </Col>
                ))}
            </Row>
            <span className="salaryInfo">{salaryInfo}</span>
        </Container>
    );
};

export default Welcome;
